import { makeAutoObservable, runInAction } from 'mobx';
import goxApi from 'api/gox-api';
import Zone from './Zone';

class Zones {

  list = [];
  storage = {};

  constructor() {
    makeAutoObservable(this);
  }

  async fetch(lat, lng) {
    return new Promise(async (resolve, reject) => {
      try {
        const { zones } = await goxApi.scootersAvailable(lat, lng);
        runInAction(() => {
          this.list = [];
          zones?.forEach(zone => {
            this.list.push(zone.id);
            this.storage[zone.id] = new Zone(zone);
          });
          resolve();
        });
      } catch (err) {
        reject(err);
      }
    });
  }

  fetchParkingZones(scooterId) {
    return new Promise(async (resolve, reject) => {
      try {
        const { parking_zones } = await goxApi.parkingZones(scooterId);
        runInAction(() => {
          this.list = [];
          parking_zones?.forEach(zone => {
            this.list.push(zone.id);
            this.storage[zone.id] = new Zone(zone);
          });
          resolve();
        });
      } catch (err) {
        reject(err);
      }
    });
  }

  find(id) {
    return this.storage[id] ?? null;
  }
   
}

const ZonesStore = new Zones();
export default ZonesStore;
